import { createApi } from '@reduxjs/toolkit/query/react'
import { queryParams } from '../../../Utils'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const promosApiService = createApi({
  reducerPath: 'promosApi',
  baseQuery: createNeighborhoodAwareBaseQuery('/promo/'),
  endpoints: (builder) => ({
    getPromos: builder.query({
      query: (args) => {
        let { id } = args

        if (id) {
          return `get/${id}`
        }

        let query = queryParams(args)

        return `get${query}`
      },
      keepUnusedDataFor: 0
    }),
    createPromo: builder.mutation({
      query: (body) => ({
        url: `create`,
        method: "POST",
        body
      })
    }),
    updatePromo: builder.mutation({
      query: (payload) => ({
        url: `update/${payload._id}`,
        method: "PUT",
        body: payload
      })
    }),
    deletePromo: builder.mutation({
      query: (id) => ({
        url: `delete/${id}`,
        method: "DELETE"
      })
    }),
  })
})

export const {
  useGetPromosQuery,
  useCreatePromoMutation,
  useUpdatePromoMutation,
  useDeletePromoMutation
} = promosApiService